import { render, staticRenderFns } from "./CreateInvoice.vue?vue&type=template&id=6ad99b3d&"
import script from "./CreateInvoice.vue?vue&type=script&lang=ts&"
export * from "./CreateInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports